import { render, staticRenderFns } from "./process-properties.vue?vue&type=template&id=2129c333"
import script from "./process-properties.vue?vue&type=script&lang=js"
export * from "./process-properties.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports